import {ProviderModel} from './ProviderModel';
import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ContractTypeModel} from './ContractTypeModel';
import {ResourcesUnitModel} from './ResourcesUnitModel';
import {CurrencyModel} from './CurrencyModel';
import { ServiceVariantModel } from './ServiceVariantModel';

export class TerminationFeeModel {

  numAnnoMese: number;
  provider: ProviderModel;
  region: RegionModel;
  localCustomer: LocalCustomerModel;
  contractType: ContractTypeModel;
  serviceVariant: ServiceVariantModel;
  currency: CurrencyModel;z
  terminationFee: number;


  constructor(numAnnoMese?: number, provider?: ProviderModel, region?: RegionModel,
              localCustomer?: LocalCustomerModel, contractType?: ContractTypeModel,
              serviceVariant?: ServiceVariantModel, currency?: CurrencyModel, terminationFee?: number) {
    this.numAnnoMese = numAnnoMese;
    this.provider = provider;
    this.region = region;
    this.localCustomer = localCustomer;
    this.contractType = contractType;
    this.serviceVariant = serviceVariant;
    this.currency = currency;
    this.terminationFee = terminationFee;
  }
}
